import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';

export function EnumLabel(props: { value?: string | undefined | null; enumName: string }) {
    const translate = useTranslate();

    if (!props.value) {
        return null;
    }
    const text = translate(`${props.enumName}.${props.value}`);
    return <span title={text}>{text}</span>;
}
